export const PaymentMethod = {
    CREDIT: 1,
    DEBIT: 2,
    VOUCHER: 4,
    MONEY: 8,
    FISICO: 16,
    ONLINE: 32,
    MEAL: 64,
    FOOD: 128
}

export const Importance = {
    HIGH: 100,
    MEDIUM_HIGH: 80,
    MEDIUM: 50,
    LOW_MEDIUM: 40,
    LOW: 20,
}

export const PaymentStatus = {
    WAITING: 0,
    PAYED: 1
}

export const Method = {

    ABRAPETITE_ALIMENTACAO: {
        alias: 'ABRAPETITE_ALIMENTACAO',
        name: 'Abrapetite',
        type: PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    ABRAPETITE_REFEICAO: {
        'alias': 'ABRAPETITE_REFEICAO',
        'name': 'Abrapetite',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    ALELO_ALIMENTACAO: {
        'alias': 'ALELO_ALIMENTACAO',
        'name': 'Alelo',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.HIGH
    },

    ALELO_REFEICAO: {
        'alias': 'ALELO_REFEICAO',
        'name': 'Alelo',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.HIGH
    },

    AMERICAN_EXPRESS: {
        'alias': 'AMERICAN_EXPRESS',
        'name': 'American Express',
        'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM
    },

    AMEX: {
        'alias': 'AMEX',
        'name': 'Amex',
        'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM
    },

    AURA: {
        'alias': 'AURA',
        'name': 'Aura',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BANESE: {
        'alias': 'BANESE',
        'name': 'Banese',
        'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BANESCARD_CREDITO: {
        'alias': 'BANESCARD_CREDITO',
        'name': 'Banescard',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO | PaymentMethod.ONLINE,
        'importance': Importance.LOW
    },

    BANESCARD_DEBITO: {
        'alias': 'BANESCARD_DEBITO',
        'name': 'Banescard',
        'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BANRICOMPRAS: {
        'alias': 'BANRICOMPRAS',
        'name': 'Banricompras',
        'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BANRICARD_ALIMENTACAO: {
        'alias': 'BANRICARD_ALIMENTACAO',
        'name': 'Banricard',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BANRICARD_REFEICAO: {
        'alias': 'BANRICARD_REFEICAO',
        'name': 'Banricard',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BIGCARD: {
        'alias': 'BIGCARD',
        'name': 'BigCard',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BRASILCARD: {
        'alias': 'BRASILCARD',
        'name': 'BrasilCard',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    CABAL: {
        'alias': 'CABAL',
        'name': 'Cabal',
        'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO | PaymentMethod.ONLINE,
        'importance': Importance.LOW
    },

    CABAL_ALIMENTACAO: {
        'alias': 'CABAL_ALIMENTACAO',
        'name': 'Cabal',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    CABAL_REFEICAO: {
        'alias': 'CABAL_REFEICAO',
        'name': 'Cabal',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    COMPROCARD_ALIMENTACAO: {
        'alias': 'COMPROCARD_ALIMENTACAO',
        'name': 'Comprocard',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    COMPROCARD_REFEICAO: {
        'alias': 'COMPROCARD_REFEICAO',
        'name': 'Comprocard',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    COOPER: {
        'alias': 'COOPER',
        'name': 'Cooper',
        'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE,
        'importance': Importance.LOW
    },

    COOPERCARD_ALIMENTACAO: {
        'alias': 'COOPERCARD_ALIMENTACAO',
        'name': 'Coopercard',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    COOPERCARD_REFEICAO: {
        'alias': 'COOPERCARD_REFEICAO',
        'name': 'Coopercard',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    CREDI_ALIMENTACAO: {
        'alias': 'CREDI_ALIMENTACAO',
        'name': 'Credi',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    CREDI_REFEICAO: {
        'alias': 'CREDI_REFEICAO',
        'name': 'Credi',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    CREDISHOP: {
        'alias': 'CREDISHOP',
        'name': 'Credishop',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    CREDZ_CREDITO: {
        'alias': 'CREDZ_CREDITO',
        'name': 'Credz',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    CREDZ_DEBITO: {
        'alias': 'CREDZ_DEBITO',
        'name': 'Credz',
        'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    DINERS_CLUB: {
        'alias': 'DINERS_CLUB',
        'name': 'Diners Club',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    DINHEIRO: {
        'alias': 'DINHEIRO',
        'name': 'Dinheiro',
        'type': PaymentMethod.MONEY | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    DISCOVER: {
        'alias': 'DISCOVER',
        'name': 'Discover',
        'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO | PaymentMethod.ONLINE,
        'importance': Importance.LOW
    },

    DINNERS: {
        'alias': 'DINNERS',
        'name': 'Dinners',
        'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    ELO: {
        'alias': 'ELO',
        'name': 'Elo',
        'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM_HIGH
    },

    GREEN_CARD_ALIMENTACAO: {
        'alias': 'GREEN_CARD_ALIMENTACAO',
        'name': 'Green Card',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    GREEN_CARD_REFEICAO: {
        'alias': 'GREEN_CARD_REFEICAO',
        'name': 'Green Card',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    GOOD: {
        'alias': 'GOOD',
        'name': 'Good',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    HIPER: {
        'alias': 'HIPER',
        'name': 'Hiper',
        'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM_HIGH
    },

    HIPERCARD: {
        'alias': 'HIPERCARD',
        'name': 'Hipercard',
        'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE,
        'importance': Importance.MEDIUM_HIGH
    },

    JCB: {
        'alias': 'JCB',
        'name': 'Jcb',
        'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO | PaymentMethod.ONLINE,
        'importance': Importance.LOW
    },

    MAIS: {
        'alias': 'MAIS',
        'name': 'Mais!',
        'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    MAESTRO: {
        'alias': 'MAESTRO',
        'name': 'Maestro',
        'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    MASTERCARD: {
        'alias': 'MASTERCARD',
        'name': 'Mastercard',
        'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.HIGH
    },

    ONE_CARD: {
        'alias': 'ONE_CARD',
        'name': 'One Card',
        'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    ONE_CARD_ALIMENTACAO: {
        'alias': 'ONE_CARD_ALIMENTACAO',
        'name': 'One Card',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    PLANVALE_ALIM: {
        'alias': 'PLANVALE_ALIM',
        'name': 'PlanVale',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    PLANVALE_REF: {
        'alias': 'PLANVALE_REF',
        'name': 'PlanVale Ref.',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    PERSONAL_CARD_ALIMENTACAO: {
        'alias': 'PERSONAL_CARD_ALIMENTACAO',
        'name': 'Personal Card',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    PERSONAL_CARD_REFEICAO: {
        'alias': 'PERSONAL_CARD_REFEICAO',
        'name': 'Personal Card',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    PIX: {
        'alias': 'PIX',
        'name': 'Pix',
        'type': PaymentMethod.MONEY | PaymentMethod.ONLINE,
        'importance': Importance.MEDIUM_HIGH
    },

    POLICARD_ALIMENTACAO: {
        'alias': 'POLICARD_ALIMENTACAO',
        'name': 'Policard',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    POLICARD_REFEICAO: {
        'alias': 'POLICARD_REFEICAO',
        'name': 'Policard ',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BEN_ALIMENTACAO: {
        'alias': 'BEN_ALIMENTACAO',
        'name': 'Ben Alimentação',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    BEN_REFEICAO: {
        'alias': 'BEN_REFEICAO',
        'name': 'Ben Refeição',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    IFOOD_REFEICAO: {
        'alias': 'IFOOD_REFEICAO',
        'name': 'Ifood Refeição',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    ELO_REFEICAO: {
        'alias': 'ELO_REFEICAO',
        'name': 'Elo Refeição',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    IFOOD_SALDOLIVRE: {
        'alias': 'IFOOD_SALDOLIVRE',
        'name': 'Ifood Saldo Livre',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    PLUXEE_REFEICAO: {
        'alias': 'PLUXEE_REFEICAO',
        'name': 'Pluxee Refeição',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    PLUXEE_ALIMENTACAO: {
        'alias': 'PLUXEE_ALIMENTACAO',
        'name': 'Pluxee Alimentação',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    PANAL: {
        'alias': 'PANAL',
        'name': 'Panal',
        'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    REDESHOP_DEBITO: {
        'alias': 'REDESHOP_DEBITO',
        'name': 'RedeShop',
        'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM
    },

    SENFF: {
        'alias': 'SENFF',
        'name': 'Senff',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SENFF_ALIMENTACAO: {
        'alias': 'SENFF_ALIMENTACAO',
        'name': 'Senff',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SENFF_REFEICAO: {
        'alias': 'SENFF_REFEICAO',
        'name': 'Senff Refeicão',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SOROCRED: {
        'alias': 'SOROCRED',
        'name': 'Sorocred',
        'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SORO_VALE_ALIMENTACAO: {
        'alias': 'SORO_VALE_ALIMENTACAO',
        'name': 'Soro Vale',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SORO_VALE_REFEICAO: {
        'alias': 'SORO_VALE_REFEICAO',
        'name': 'Soro Vale',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SICREDI: {
        'alias': 'SICREDI',
        'name': 'Sicredi',
        'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SAPORE_MERCATO: {
        'alias': 'SAPORE_MERCATO',
        'name': 'Sapore Mercato',
        'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SAPORE_RISTORANTE: {
        'alias': 'SAPORE_RISTORANTE',
        'name': 'Sapore Ristorante',
        'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    SODEXO_REFEICAO: {
        'alias': 'SODEXO_REFEICAO',
        'name': 'Sodexo',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM_HIGH
    },

    SODEXO_ALIMENTACAO: {
        'alias': 'SODEXO_ALIMENTACAO',
        'name': 'Sodexo',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM_HIGH
    },

    TICKET_ALIMENTACAO: {
        'alias': 'TICKET_ALIMENTACAO',
        'name': 'Ticket',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.HIGH
    },

    TICKET_RESTAURANTE_REFEICAO: {
        'alias': 'TICKET_RESTAURANTE_REFEICAO',
        'name': 'Ticket Restaurante',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.HIGH
    },

    UNIONPAY: {
        'alias': 'UNIONPAY',
        'name': 'UnionPay',
        'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE,
        'importance': Importance.LOW
    },

    USECRED_REFEICAO: {
        'alias': 'USECRED_REFEICAO',
        'name': 'Usecred Refeicao',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    USECRED_ALIMENTACAO: {
        'alias': 'USECRED_ALIMENTACAO',
        'name': 'Usecred',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VALECARD_ALIMENTACAO: {
        'alias': 'VALECARD_ALIMENTACAO',
        'name': 'Valecard',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VALECARD_REFEICAO: {
        'alias': 'VALECARD_REFEICAO',
        'name': 'Valecard',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VALE_MAIS_ALIMENTACAO: {
        'alias': 'VALE_MAIS_ALIMENTACAO',
        'name': 'Vale Mais',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VALE_MAIS_REFEICAO: {
        'alias': 'VALE_MAIS_REFEICAO',
        'name': 'Vale mais refeição ',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VERDE_CARD: {
        'alias': 'VERDE_CARD',
        'name': 'Verde Card',
        'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VEROCARD_REFEICAO: {
        'alias': 'VEROCARD_REFEICAO',
        'name': 'Verocard',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VEROCARD_ALIMENTACAO: {
        'alias': 'VEROCARD_ALIMENTACAO',
        'name': 'Verocard',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VISA: {
        'alias': 'VISA',
        'name': 'Visa',
        'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
        'importance': Importance.HIGH
    },

    VISA_ELECTRON: {
        'alias': 'VISA_ELECTRON',
        'name': 'Visa Electron',
        'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
        'importance': Importance.LOW
    },

    VISA_VALE_ALIMENTACAO: {
        'alias': 'VISA_VALE_ALIMENTACAO',
        'name': 'Visa Vale',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM
    },

    VISA_VALE_REFEICAO: {
        'alias': 'VISA_VALE_REFEICAO',
        'name': 'Visa Vale',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM
    },

    VR_ALIMENTACAO: {
        'alias': 'VR_ALIMENTACAO',
        'name': 'VR',
        'type': PaymentMethod.FOOD | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM_HIGH
    },

    VR_REFEICAO: {
        'alias': 'VR_REFEICAO',
        'name': 'VR',
        'type': PaymentMethod.MEAL | PaymentMethod.VOUCHER | PaymentMethod.FISICO,
        'importance': Importance.MEDIUM_HIGH
    },
    EASY_COINS: {
        'alias': 'EASY_COINS',
        'name': 'Créditos',
        'type': PaymentMethod.MONEY | PaymentMethod.ONLINE,
        'importance': Importance.LOW
    }
}